import styled from 'styled-components';
import { Text } from '@bpba/ui-components';
import { ComponentProps } from 'react';

type Props = ComponentProps<typeof Text> & {
  show: boolean | undefined;
};

export const CustomText = styled(Text)<Props>((props) => ({
  display: props.show ? 'unset' : 'none',
}));
